export default __webpack_public_path__ + "static/elf-example-1-b49a7cb485c3e539806daedcad6353c0.png";